const INDUSTRIES = [
  { title: 'Fintech', desc: 'KYC, payments, lending and compliance-heavy workflows' },
  { title: 'Healthcare', desc: 'Patient apps, scheduling, GDPR-grade data handling' },
  { title: 'E-commerce', desc: 'Storefronts, checkout, catalogue and order automation' },
  { title: 'Hospitality', desc: 'Booking engines, guest apps, channel integrations' },
  { title: 'Logistics', desc: 'Dispatch, tracking, route planning, carrier portals' },
  { title: 'Real estate', desc: 'Listings, property management, tenant portals' },
];
export default INDUSTRIES;
